import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="send"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M120-160v-240l320-80-320-80v-240l760 320-760 320Z" />
  </svg>
);
export default SvgComponent;
